import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Spin,
  Select,
  InputNumber,
  Modal,
  DatePicker,
  Input,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { save } from "../../../../../../../features/save/saveSlice";
import { compStatusData } from "../../../../../../../data";

const ComponentAdd = ({ isModalOpen, handleCancel, handleFetch, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const { activeObjOngoingProject } = useSelector((state) => ({
    activeObjOngoingProject: state.obj.activeObj["ongoingProject"],
  }));
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onFinish = async (data) => {
    data.componentId = prodd?.componentId ? prodd?.componentId : null;
    data.compProjectId = activeObjOngoingProject?.projectId;
    const res = await dispatch(
      save({
        ...data,
        url: "api/v2/mainProject/components/save",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleFetch();
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue({
        ...prodd,
      });
    } else {
      form.resetFields();
    }
  }, [prodd, form]);

  return (
    <Modal
      title={`${prodd?.componentId ? "Update Component" : "Add a Component"}`}
      open={isModalOpen}
      onOk={onFinish}
      onCancel={handleCancel}
      className="!w-[59.5rem]"
      maskClosable={false}
    >
      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className=""
        style={{
          maxWidth: "100%",
        }}
        form={form}
      >
        <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
          <Form.Item
            name="compName"
            className=""
            label={"Component Name"}
            rules={[
              {
                required: true,
                message: "Please add component name",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>
          <Form.Item
            name="compWeight"
            label={"Weight (%)"}
            rules={[
              {
                required: true,
                message: "Please add weight (%",
              },
            ]}
          >
            <InputNumber
              suffix="%"
              min={0}
              max={100}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              placeholder="Enter value"
              className="input flex"
            />
          </Form.Item>
          <Form.Item
            name="compPercentageCompleted"
            label={"Percentage Completed (%)"}
            rules={[
              {
                required: true,
                message: "Please add Percentage completed (%",
              },
            ]}
          >
            <InputNumber
              suffix="%"
              min={0}
              max={100}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              placeholder="Enter value"
              className="input flex"
            />
          </Form.Item>
          
        </div>

        <div className="flex justify-between mt-[48px] ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center mb-[58px] gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[200px]">
              <button
                disabled={saving}
                key="submit"
                type="submit"
                className="cstm-btn-2"
              >
                {saving ? (
                  <Spin />
                ) : prodd?.componentId ? (
                  "Update Component"
                ) : (
                  "Save Component"
                )}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default ComponentAdd;
